import React from 'react';
import PropTypes from 'prop-types';

import clsx from 'clsx';

const CardHeader = ({ variant = 'default', children, className, ...props }) => {
  return (
    <div
      className={clsx(
        'flex flex-row flex-wrap justify-between items-start',
        {
          'px-4 mb-2': variant === 'card',
          'px-4 border-b border-gray-100': variant === 'root',
          'pb-4 min-h-16 gap-y-4': variant === 'root',
        },
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};

CardHeader.propTypes = {
  variant: PropTypes.oneOf(['root', 'card', 'default']),
};

export default CardHeader;
